<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && twins.length===0">{{ $t('twins.no_backup_available' )}}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xs12 sm6 md4 lg4 xl3 v-for="item in twins" :key="item.name">
      <twins-item :item="item" @click="onItemClicked"></twins-item>
    </v-flex>
  </v-layout>

  <twins-detail v-if="dialogDetail" v-model="dialogDetail" :item="dialogDetailData" @restore="restoreItemConfirm" @delete="deleteItemConfirm" @cancel="cancel" @toast="val=>$emit('toast',val)"></twins-detail>

  <v-btn color="secondary" dark fixed bottom right fab @click="backup" :disabled="!canBackup" v-if="!loading">
    <v-icon>backup</v-icon>
  </v-btn>

  <confirm-dialog :config="confirm" @answer="confirmAnswer"></confirm-dialog>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import TwinsItem from './TwinsItem'
import TwinsDetailDialog from './TwinsDetailDialog'

export default {
  name: 'Twins',
  mixins: [UserAuth],
  components: {
    'twins-item': TwinsItem,
    'twins-detail': TwinsDetailDialog
  },
  data() {
    return {
      twins: [],
      twinsLoading: true,
      confirm: {
        visible: false,
        type: '',
        item: null,
        question: ''
      },
      dialogDetail: false,
      dialogDetailData: null,
    }
  },
  computed: {
    loading() {
      return this.userLoading || this.twinsLoading;
    },
    backuping() {
      return ((this.twins || {})[0] || {}).name == '0'
    },
    mac() {
      return this.$route.params.mac;
    },
    canBackup() {
      return !this.backuping && !this.twinsLoading && Object.keys(this.twins).length < 20;
    }
  },
  methods: {
    onItemClicked(item) {
      this.dialogDetailData = item;
      this.dialogDetail = true;
    },
    async backup() {
      let task = await this.sendCommand({
        mac: this.mac,
        cmd: 'backup',
        uid: this.userId
      }, {
        denied: this.$t('twins.permission_denied'),
        starting: this.$t('twins.backup_starting', {
          mac: (this.userMacInfo[this.mac] || {}).hostname || this.mac
        }),
        success: this.$t('twins.backup_success', {
          mac: (this.userMacInfo[this.mac] || {}).hostname || this.mac
        })
      })
      this.listenBackupForPopup(this.mac, task);
    },
    listenBackupForPopup(mac, task) {
      if (task) this.$db.ref('macTwins').child(mac).child(task).on('value', snapshot => {
        let val = snapshot.val();
        if (val && val.name && val.name.match(/\d+T\d+Z/)) {
          snapshot.ref.off();
          this.$emit('toast', this.$t('twins.backup_successfully', {
            mac: (this.userMacInfo[mac] || {}).hostname || mac
          }));
        }
      });
    },
    confirmAnswer(answer) {
      this.confirm.visible = false;
      if (answer) switch (this.confirm.type) {
        case 'restore':
          this.restoreItem(this.confirm.item);
          break;
        case 'delete':
          this.deleteItem(this.confirm.item);
          break;
      }
    },
    async restoreItemConfirm(item) {
      this.dialogDetail = false;
      this.confirm.question = this.$t('twins.confirm_restore', {
        name: new Date(item.timestamp).toLocaleString()
      });
      this.confirm.type = 'restore';
      this.confirm.item = item;
      this.confirm.visible = true;
    },
    restoreItem(item) {
      this.sendCommand({
        mac: this.mac,
        cmd: 'restore',
        name: item.name,
        uid: this.userId,
        target: item['.key']
      }, {
        denied: this.$t('twins.permission_denied'),
        starting: this.$t('twins.restore_starting', {
          name: item.name
        }),
        success: this.$t('twins.restore_success', {
          name: item.name
        })
      })
    },
    async deleteItemConfirm(item) {
      this.dialogDetail = false;
      this.confirm.question = this.$t('twins.confirm_delete', {
        name: new Date(item.timestamp).toLocaleString()
      });
      this.confirm.type = 'delete';
      this.confirm.item = item;
      this.confirm.visible = true;
    },
    deleteItem(item) {
      this.sendCommand({
        mac: this.mac,
        cmd: 'purge',
        name: item.name,
        uid: this.userId,
        target: item['.key']
      }, {
        denied: this.$t('twins.permission_denied'),
        starting: this.$t('twins.purge_starting', {
          name: item.name
        }),
        success: this.$t('twins.purge_success', {
          name: item.name
        })
      })
    },
    cancel(task) {
      this.dialogDetail = false;
      this.sendCommand({
        mac: this.mac,
        cmd: 'cancel',
        target: task
      }, {
        denied: this.$t('twins.permission_denied'),
        starting: this.$t('twins.cancel_starting', {
          mac: (this.userMacInfo[this.mac] || {}).hostname || this.mac
        }),
        success: this.$t('twins.cancel_success', {
          mac: (this.userMacInfo[this.mac] || {}).hostname || this.mac
        })
      })
    },
    async sendCommand(cmd, msg) {
      let ref = this.$db.ref('command/twins').push();
      try {
        await ref.set(cmd);
      } catch (err) {
        this.$emit('toast', msg.denied);
        return;
      }
      this.$emit('toast', msg.starting);
      ref.on('child_added', snapshot => {
        let val;
        switch (snapshot.key) {

          case 'result':
            ref.off();
            val = snapshot.val();
            if (val) {
              this.$emit('toast', msg.success);
            }
            break;

          case 'error':
            ref.off();
            val = snapshot.val();
            if (val) this.$emit('toast', val);
            break;
        }
      });
      return ref.key;
    }
  },
  mounted() {
    this.$bindAsArray('twins', this.$db.ref('macTwins').child(this.mac).limitToFirst(20), null, function() {
      this.twinsLoading = false;
      (this.twins || []).filter(twin => twin.name == '0').forEach(twin => this.listenBackupForPopup(this.mac, twin['.key']));
    });
  },
  beforeDestroy() {
    this.$db.ref('macTwins').child(this.userId).off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/twins/Twins.vue